"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../utils/constants");
var muiBooster16 = {
    paths: [
        {
            path: 'M10.9127201,5.83044693 C10.8599546,5.73070455 10.7463146,5.6666888 10.6211332,5.6666888 L6.80723242,5.6666888 L10.5712342,0.434928584 C10.6339946,0.347670601 10.6378417,0.237170385 10.5812291,0.146791302 C10.5245788,0.0561133908 10.4164076,0 10.2992599,0 L5.14970178,0 C5.02772635,0 4.91634928,0.0606290247 4.86166024,0.156685853 L0.0339377123,8.65670245 C-0.015961326,8.74425927 -0.0104924216,8.84851728 0.0480814306,8.93208971 C0.106994732,9.01566214 0.210300451,9.06666224 0.321979251,9.06666224 L3.63153391,9.06666224 L0.0252251818,16.6067414 C-0.0362528473,16.7356694 0.0184739136,16.8852498 0.153951877,16.9583632 C0.206076194,16.9864199 0.264008864,17 0.321639802,17 C0.414007712,17 0.505093258,16.9651367 0.5681931,16.8994275 L10.8673471,6.13272877 C10.9480983,6.04832627 10.9654856,5.93045494 10.9127201,5.83044693 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Booster',
    width: 11,
    height: 17,
};
var muiBooster24 = {
    paths: [
        {
            path: 'M11.9669516,7.2023168 C11.9090886,7.07910562 11.7844703,7.00002734 11.6471957,7.00002734 L7.46485017,7.00002734 L11.5924761,0.537264721 C11.6612995,0.429475448 11.6655183,0.292975182 11.6034366,0.181330432 C11.5413135,0.0693165416 11.4226924,0 11.2942276,0 L5.64719255,0 C5.5134336,0 5.39129686,0.0748946775 5.33132454,0.193553112 L0.0372162903,10.6935736 C-0.0175032818,10.801732 -0.0115060498,10.9305213 0.052726373,11.0337579 C0.117331038,11.1369944 0.230616682,11.1999945 0.353084296,11.1999945 L3.98236095,11.1999945 L0.0276620793,20.51421 C-0.0397550805,20.673474 0.0202585998,20.8582497 0.168824513,20.9485663 C0.225984338,20.9832246 0.289513637,21 0.352712054,21 C0.454003235,21 0.553888168,20.9569335 0.623083817,20.8757634 L11.9171952,7.57572378 C12.0057474,7.47146186 12.0248145,7.32585611 11.9669516,7.2023168 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Booster',
    width: 12,
    height: 21,
};
var muiBooster = {
    base: muiBooster16,
    smIcon: muiBooster16,
    lgIcon: muiBooster24,
};
exports.muiBooster = muiBooster;
//# sourceMappingURL=booster.js.map